import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserBroadcastState } from "./types";
import { IUser } from "@/shared/api/users";

const initialState: UserBroadcastState = {
    isUserBroadcastModalOpen: false,
    currentUser: null,
    onSuccess: null
}

interface OpenUserBroadcastModal {
    data: IUser
    onSuccess?: () => void
}

const userBroadcastSlice = createSlice({
    name: 'userBroadcast',
    initialState,
    reducers: {
        openUserBroadcastModal: (state, action: PayloadAction<OpenUserBroadcastModal>) => {
            state.isUserBroadcastModalOpen = true
            state.currentUser = action.payload.data
            state.onSuccess = action.payload.onSuccess || null
        },
        closeUserBroadcastModal: (state) => {
            state.isUserBroadcastModalOpen = false
            state.currentUser = null
            state.onSuccess = null
        },
    }
})

export default userBroadcastSlice.reducer
export const { 
    closeUserBroadcastModal,
    openUserBroadcastModal
} = userBroadcastSlice.actions

